import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable} from 'rxjs/Observable';

@Injectable()

export class Translate {

  constructor(public translate: TranslateService) {}

  translateGroup(arrayData) {
    let newObj = {};
    let obs = new Observable(observer => {
      arrayData.forEach(element => {
        this.translate.get(element).subscribe(elementTranslate => {
          newObj[element] = elementTranslate;
        })
      });

      observer.complete();
    });

    return new Promise((resolve, reject) => {
      obs.subscribe(
        () => false,
        err => false,
        () => resolve(newObj)
      )
    });
  }

  translateChar(char) {
    return new Promise((resolve, reject) => {
      this.translate.get(char).subscribe(elementTranslate => {
        resolve(elementTranslate);
      })
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/translate.ts